import React from "react"
import { Badge } from "antd"

const GuestBadge = ({ show, children }) => {
    if (show)
        return <Badge.Ribbon text="Guest" color="cyan">{ children }</Badge.Ribbon>

    return children
}

export default GuestBadge